// Set the configuration for your app
const CONFIG = {
	apiKey: "AIzaSyBqU_MDmTwv5RtyeovGhuz-lpLsKKK3k-4",
	authDomain: "cc-proposal-tool.firebaseapp.com",
	databaseURL: "https://cc-proposal-tool.firebaseio.com",
	projectId: "cc-proposal-tool",
	storageBucket: "cc-proposal-tool.appspot.com",
	messagingSenderId: "359594190366"
};

let provider = new firebase.auth.GoogleAuthProvider();

firebase.initializeApp(CONFIG);

// Get a reference to the database service
let proposals = {
	getProposals(cb) {
		console.log('get all Proposals');

		let proposals = firebase.database().ref('proposals').orderByChild('timestamp');

		proposals.on('value', (snapshot) => {
			let proposals = snapshot.val();

			if (proposals === null || proposals === undefined) {
				cb([]);
				return;
			}
			cb(proposals);
		});

	},
	getProposal(id, cb) {
		console.log('get Proposal');

		let proposal = firebase.database().ref('proposals').child(id);

		proposal.off('value');
		proposal.on('value', (snapshot) => {
			let proposal = snapshot.val();
			if (proposal === null || proposal === undefined) {
				return
			}
			cb(proposal);
		});
	},

	offProposal(id) {
		firebase.database().ref('proposals').child(id).off('value');
	},

	updateProjectInfo(proposalInfo, cb) {
		console.log('update Proposal Info', proposalInfo['Status']);

		let proposals = firebase.database().ref('proposals');
		let proposal = proposals.child(proposalInfo.id);

		proposal.update({
			id: proposalInfo.id,
			"Internal-Name": proposalInfo['Internal-Name'] || '',
            "Type": proposalInfo['Type'],
			"Client-Name": proposalInfo['Client-Name'],
			"Contact-Person": proposalInfo['Contact-Person'],
			"Street": proposalInfo['Street'],
			"Place": proposalInfo['Place'],
			"Project-Number": proposalInfo['Project-Number'],
			"Project-Description": proposalInfo['Project-Description'],
            "Updated-Project-Id": proposalInfo['Updated-Project-Id'] || '',
            "Predecessor-Project-Id": proposalInfo['Predecessor-Project-Id'] || '',
			"Date": proposalInfo['Date'],
			"Status": proposalInfo['Status'] || 'draft',
			"company-id": proposalInfo['company-id'] || '',
			"Logo-Position": proposalInfo['Logo-Position'] || 'left',
		});
	},

	updateConfirmation(data) {
		console.log('update Proposal Confirmation');

		firebase.database().ref('proposals').child(data.id).update({
			"Project-Confirmation": data['Project-Confirmation'],
		});
	},

	updateMilestones(milestones, id, cb) {
		console.log('update Milestones');

		firebase.database().ref('proposals').child(id).update({
			"milestones": milestones
		});
	},

	createProposal(proposal, cb) {
		console.log('Create Proposal');

		let mRef = firebase.database().ref('proposals');
		let key = firebase.database().ref('proposals').push().key;
		let newProposal = firebase.database().ref('proposals/' + key);
		newProposal.set({
			id: key,
			"Internal-Name": proposal['Internal-Name'] || '',
            "Type": proposal['Type'] || 'Angebot',
			"Client-Name": proposal['Client-Name'],
			"Contact-Person": proposal['Contact-Person'],
			"Street": proposal['Street'],
			"Place": proposal['Place'],
			"Project-Number": proposal['Project-Number'],
			"Project-Description": proposal['Project-Description'],
			"Project-Confirmation": proposal['Project-Confirmation'],
            "Updated-Project-Id": proposal['Updated-Project-Id'] || '',
            "Predecessor-Project-Id": proposal['Predecessor-Project-Id'] || '',
			"Status" : proposal['Status'],
			"Date": proposal['Date'],
			"timestamp": proposal['timestamp'],
			"milestones": proposal['milestones'],
			"company-id": proposal['company-id'] || '',
		});
		newProposal.once('value', (snapshot) => {
			let proposal = snapshot.val();
			if (proposal === null || proposal === undefined) {
				return
			}
			cb(proposal);
		});
	},

	duplicateProposal(id, cb) {
		console.log('duplicate Proposal');

		firebase.database().ref('proposals/' + id).once('value').then((snapshot) => {
			let proposal = snapshot.val();
			console.log(proposal);
			let newID = firebase.database().ref('proposals').push(proposal).key;
			let newProposal = firebase.database().ref('proposals').child(newID);

			newProposal.update({
				id: newID,
                "Internal-Name": proposal['Internal-Name'] + ' copy',
                "Project-Number": '',
                "Predecessor-Project-Id": proposal.id,
                "Date": '',
                Status: "draft"
            });

			newProposal.once('value', (snapshot) => {
				let proposal = snapshot.val();
				if (proposal === null || proposal === undefined) {
					return
				}
				if (cb) cb(proposal);
			});
		});
	},

	removeProposal(id) {
		console.log('Remove Proposal');
		console.log(id);
		firebase.database().ref('proposals').child(id).remove();
	}
}

export default proposals



// WEBPACK FOOTER //
// ./src/api/proposals.js